import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CabsandFuelPage } from './cabsand-fuel';

@NgModule({
  declarations: [
    CabsandFuelPage,
  ],
  imports: [
    IonicPageModule.forChild(CabsandFuelPage),
  ],
})
export class CabsandFuelPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cabsand-fuel/cabsand-fuel.module.ts